import { dateTime } from '@gravity-ui/date-utils';
export function createPlaceholderValue({ placeholderValue, timeZone }) {
    return (placeholderValue !== null && placeholderValue !== void 0 ? placeholderValue : dateTime({ timeZone }).set('hour', 0).set('minute', 0).set('second', 0));
}
export function isInvalid(value, minValue, maxValue) {
    if (!value) {
        return false;
    }
    if (minValue && value.isBefore(minValue)) {
        return true;
    }
    if (maxValue && maxValue.isBefore(value)) {
        return true;
    }
    return false;
}
export function mergeDateTime(date, time) {
    return date
        .set('hours', time.hour())
        .set('minutes', time.minute())
        .set('seconds', time.second());
}
